// The saved order image has this width whatever the screen size, so every order gets the same quality.
const OUTPUT_WIDTH = 1200;
const CAPTURE_TIMEOUT = 20000;

// Renders the editor preview (including its <svg>/<canvas> layers) to a PNG data URL.
// Elements marked `data-html2canvas-ignore` (map controls, buttons) are left out.
export async function capturePreview(html2canvas, element) {
    if (!element || !element.offsetWidth) {
        throw new Error('Preview element is not rendered');
    }
    // A capture made before the web fonts load would bake fallback fonts into the order image.
    if (document.fonts) await document.fonts.ready;

    let timer;
    const timeout = new Promise((resolve, reject) => {
        timer = setTimeout(() => reject(new Error('Preview capture timed out')), CAPTURE_TIMEOUT);
    });
    try {
        const canvas = await Promise.race([
            html2canvas(element, {
                proxy: 'server.js',
                useCORS: true,
                scale: OUTPUT_WIDTH / element.offsetWidth,
                imageTimeout: 10000,
                logging: false,
                // html2canvas clones the whole page and waits for all of its images (gallery, reviews, map tiles
                // elsewhere), which took up to 20s; only the preview subtree and the stylesheets are needed.
                ignoreElements: (node) =>
                    !(node.contains(element) || element.contains(node) || document.head.contains(node)),
            }),
            timeout,
        ]);
        return canvas.toDataURL('image/png');
    } finally {
        clearTimeout(timer);
    }
}
